import {
  SET_BRANCHES,
  SET_VALIDATORS,
  SET_FUNDS,
  SET_ASSET_TYPES,
  SET_PAYMENT_REMINDER_CLIENT_ATTITUDES,
  SET_PAYMENT_REMINDER_STATUSES,
  SET_PAYMENT_REMINDER_NEXT_ACTIONS,
  SET_CASH_LOG_CATEGORIES,
  CLEAR,
  SET_SCREEN_SIZE,
  SET_LOCATIONS,
  SET_ASSET_CATEGORIES,
  SET_VALUATORS,
  SET_PRODUCTS,
  SET_STORAGES,
  SET_CONTRACT_DOC_TYPES,
  SET_CLIENT_DOC_TYPES
} from './types';

export const INIT_STATE = {
  branches: [],
  storages: [],
  funds: [],
  locations: [],
  assetCategories: [],
  contractDocTypes: [],
  assetTypes: [],
  paymentReminderClientAttitudes: [],
  paymentReminderStatuses: [],
  paymentReminderNextActions: [],
  cashLogCategories: [],
  validators: [],
  valuators: [],
  products: [],
  screenSize: 1024,
  isMobile: false,
  isTablet: false,
  isDesktop: true
};

const mutations = {
  [SET_BRANCHES](state, { branches }) {
    state.branches = branches;
  },

  [SET_STORAGES](state, { storages }) {
    state.storages = storages;
  },

  [SET_FUNDS](state, { funds }) {
    state.funds = funds;
  },

  [SET_LOCATIONS](state, { locations }) {
    state.locations = locations;
  },

  [SET_ASSET_CATEGORIES](state, { assetCategories }) {
    state.assetCategories = assetCategories;
  },

  [SET_CONTRACT_DOC_TYPES](state, { contractDocTypes }) {
    state.contractDocTypes = contractDocTypes;
  },

  [SET_CLIENT_DOC_TYPES](state, { clientDocTypes }) {
    state.clientDocTypes = clientDocTypes;
  },

  [SET_PRODUCTS](state, { products }) {
    state.products = products;
  },

  [SET_CASH_LOG_CATEGORIES](state, { categories }) {
    state.cashLogCategories = categories;
  },

  [SET_ASSET_TYPES](state, { assetTypes }) {
    state.assetTypes = assetTypes;
  },

  [SET_PAYMENT_REMINDER_CLIENT_ATTITUDES](state, { paymentReminderClientAttitudes }) {
    state.paymentReminderClientAttitudes = paymentReminderClientAttitudes;
  },

  [SET_PAYMENT_REMINDER_STATUSES](state, { paymentReminderStatuses }) {
    state.paymentReminderStatuses = paymentReminderStatuses;
  },

  [SET_PAYMENT_REMINDER_NEXT_ACTIONS](state, { paymentReminderNextActions }) {
    state.paymentReminderNextActions = paymentReminderNextActions;
  },

  [SET_VALIDATORS](state, { validators }) {
    state.validators = validators;
  },

  [SET_VALUATORS](state, { valuators }) {
    state.valuators = valuators;
  },

  [CLEAR](state) {
    Object.keys(INIT_STATE).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(INIT_STATE, key)) {
        state[key] = INIT_STATE[key];
      }
    });
  },

  [SET_SCREEN_SIZE](state, w) {
    const breakpoint = 768;
    const breakpointTablet = 992;

    state.w = w;

    if (w < breakpoint) {
      state.isMobile = true;
      state.isTablet = false;
      state.isDesktop = false;
    } else if ((w >= breakpoint) && (w < breakpointTablet)) {
      state.isMobile = false;
      state.isTablet = true;
      state.isDesktop = false;
    } else if (w >= breakpointTablet) {
      state.isMobile = false;
      state.isTablet = false;
      state.isDesktop = true;
    }
  }
};

export default mutations;
